<span *ngIf="mergeLogsLoading">
  <i class="input-loading-spinner spinner-border spinner-border-sm"></i>
</span>
<ul *ngIf="!mergeLogsLoading">
  <li *ngFor="let mergeLog of mergeLogs">
    <i *ngIf="mergeLog.success" class="bhi-check" [matTooltip]="mergeLog.message"></i>
    <i *ngIf="!mergeLog.success" class="bhi-caution" [matTooltip]="mergeLog.message"></i>
    <span class="entityAndId" [ngClass]="[mergeLog.success ? 'greenTint' : 'redTint']">
      {{ mergeLog.comment ? mergeLog.comment :
      'Set ' + mergeLog.associatedEntityField + ' on ' + mergeLog.entity + ' #' + mergeLog.entityId }}
    </span>

    <!--
    TODO: would like to just use the comment from database once we have the backend logging meaningful and slightly less technical comments for the front-end.
    <span>{{ mergeLog.comment }}</span>
    -->
  </li>
</ul>
